<template>
  <a-form-item v-bind="fiConfig">
    <a-config-provider>
      <template #renderEmpty>
        <div style="text-align: center">
          <a-icon :type="iconSelect" :spin="iconSelect === 'sync'" style="font-size: 20px"/>
          <p>{{message}}</p>
        </div>
      </template>
    <a-select v-bind="slConfig" @change="handleChange" @search="handleSearch" v-decorator="decorator||[]"
              :disabled="disabled">
      <a-select-option v-for="d in options" :key="d.value">{{d.text}}</a-select-option>
    </a-select>
    </a-config-provider>
  </a-form-item>
</template>
<script>
  import JsUtils from '@/util/JsUtils'
  import JqHttpUtil from '@/util/JqHttpUtil'
  const INFO = {
    SEARCH: 0,
    NOTFOUND: 1,
    LOADING: 2
  }

  export default {
    props: ['label', 'selectedObj', 'placeholder', 'endpoint', 'decorator',
      'selectConfig', 'formItemConfig', 'cache', 'params', 'disabled', 'count'],
    data () {
      return {
        slConfig: {
          showSearch: true,
          placeholder: this.placeholder || 'Seleccione una opción',
          defaultActiveFirstOption: true,
          allowClear: true,
          filterOption: false,
          showArrow: false
        },
        fiConfig: {
          'label-col': {span: 3},
          'wrapper-col': {span: 21},
          label: this.label,
          'has-feedback': true
        },
        options: [],
        info: INFO,
        iconSelect: 'info-circle',
        message: 'Empiece a escribir para buscar...'
      }
    },
    beforeMount () {
      this.slConfig = {...this.slConfig, ...this.selectConfig}
      this.fiConfig = {...this.fiConfig, ...this.formItemConfig}
    },
    mounted () {
      this.timeout = undefined
      this.lastSearch = ''
      /* descarga los datos */
      this.http = new JqHttpUtil(this.endpoint + '/lookup')
    },
    methods: {
      resultsFound (value) {
        switch (value) {
          case this.info.SEARCH:
            this.iconSelect = 'info-circle'
            this.message = 'Empiece a escribir para buscar...'
            break
          case this.info.NOTFOUND:
            this.iconSelect = 'exclamation-circle'
            this.message = 'No se encontraron resultados...'
            break
          case this.info.LOADING:
            this.iconSelect = 'sync'
            this.message = 'Buscando...'
            break
        }
      },
      handleChange (value) {
        this.$emit('change', value)
        if (JsUtils.isEmpty(value)) {
          this.$emit('update:selectedObj', {})
          this.options = []
          this.resultsFound(this.info.SEARCH)
          return
        }
        for (let i = 0; i < this.options.length; i++) {
          let option = this.options[i]
          if (option.value === value) {
            this.$emit('update:selectedObj', option)
            this.options = [option]
            return
          }
        }
      },
      handleSearch (value) {
        if (this.timeout) {
          clearTimeout(this.timeout)
          this.timeout = null
        }
        this.lastSearch = value
        this.timeout = setTimeout(() => { this.loadOptions(value) }, 300)
      },
      loadOptions (value = '', loadWithEmptyValue = false) {
        if (this.lastRequest) {
          this.lastRequest.abort()
        }
        this.loading(true)
        this.resultsFound(this.info.LOADING)
        this.options = []
        if (JsUtils.isEmpty(value) && !loadWithEmptyValue) {
          value = ''
          this.resultsFound(this.info.SEARCH)
          this.loading(false)
          return
        }
        this.lastRequest = this.http.get({ddquery: value.trim(), ...(this.params || {})}
          , {
            cache: typeof this.cache === 'undefined' ? true : this.cache
          }, (response) => {
            if (JsUtils.isEmpty(response.data)) {
              this.resultsFound(this.info.NOTFOUND)
            }
            if (this.lastSearch === value) {
              this.options = response.data
            }
          }, () => {
            this.options = [{value: '', text: 'Error consultando lista'}]
          }
        ).always(() => {
          this.loading(false)
        })
      },
      loading (loading) {
        this.slConfig.loading = loading
        this.slConfig.allowClear = !loading
        this.slConfig = {...this.slConfig}
      },
      clearValue () {
        if (!this.decorator) {
          this.slConfig.value = undefined
          this.slConfig = {...this.slConfig}
          this.$nextTick(() => {
            delete this.slConfig.value
          })
        }
        this.handleChange(undefined)
      }
    },
    watch: {
      params (newValue, oldValue) {
        if (JsUtils.isEqual(newValue, oldValue)) {
          return
        }
        this.loading(false)
        this.loadOptions()
        this.clearValue()
      },
      options () {
        this.$emit('update:count', this.options ? this.options.length : 0)
      },
      formItemConfig () {
        this.fiConfig = {...this.fiConfig, ...this.formItemConfig}
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/components/ui/lookup.vue